export const LOGIN_FIREBASE = 'login'
export const ADD_TO_CART_FIREBASE = 'add_to_cart'
export const REMOVE_CART_ITEM_FIREBASE ='remove_from_cart'
export const BEGIN_CHECKOUT_PROCESS_FIREBASE = 'begin_checkout'
export const TRIAL_FIRST = "trial_first"